const AT = require("../../core/vault/ActionTypes");
const {
	takePendingHallwayCelebration,
} = require("./ContinuousPlayLessonStreakUtil");

function maybeFlushAfterBlockingModal(dispatch) {
	const data = takePendingHallwayCelebration();
	if (!data) return;
	dispatch({
		type: AT.SHOW_MESSAGE,
		messageType: "continuousPlayHallwayCelebrateStreak",
		data,
	});
}

module.exports = {
	maybeFlushAfterBlockingModal,
};
